let guestTypeCode = {
  BROKER: { code: 0, text: '仲介業者' },
  OWNER: { code: 1, text: '所有者' },
};

export default {
  code: guestTypeCode
};
